import axios from 'axios';
import config from '../config/config';

class SupporterApi {
    static getAvailableSupportersForProject(searchString) {
        if (searchString.length === 0) searchString = 'a';
        return axios.get(`${config.server.endpoint}backend/supporter/available/${searchString}/`)
    }

    static createOrAddSupporter(payload) {
        return axios.post(`${config.server.endpoint}backend/supporter`, payload);
    }

    static getTicketToasterProvisionsForSupporterProject(supporterId) {
        return axios.get(`${config.server.endpoint}backend/supporter/project/ticketToaster/${supporterId}/`)
    }

    static setTicketToasterProvisionsForSupporterProject(supporterId, provisions) {
        return axios.put(`${config.server.endpoint}backend/supporter/project/ticketToaster/${supporterId}/`, {
            ticketToasterProvisions: provisions
        });
    }

    static swapTicketToasterIdentifierForSupporterProject(supporterId, newTicketToasterIdentifier) {
        return axios.post(`${config.server.endpoint}backend/supporter/swapTicketToasterIdentifier/${supporterId}/`, {
            newTicketToasterIdentifier
        });
    }

    static setTicketToasterIdentifierForSupporterProject(supporterId, newTicketToasterIdentifier) {
        return axios.post(`${config.server.endpoint}backend/supporter/setTicketToasterIdentifier/${supporterId}/`, {
            newTicketToasterIdentifier
        });
    }

    static printSupporterProjectShiftInfo(supporterId, printerApiKey) {
        return axios.post(`${config.server.endpoint}backend/supporter/project/printShiftInfos/${supporterId}/`, {
            printerApiKey: printerApiKey
        });
    }

    static getTicketForSupporterProject(supporterId) {
        return axios.get(`${config.server.endpoint}backend/supporter/project/ticket-management/${supporterId}/`)
    }

    static createPayoutForSupporterProject(supporterId, payoutAmount, donationAmount) {
        return axios.post(`${config.server.endpoint}backend/supporter/project/ticket-management/payout/${supporterId}/`, {
            payoutAmount,
            donationAmount,
        })
    }
}

export default SupporterApi;
